import type { InitAnalyticsProps } from '@patrianna/analytics'
import getParamFromString from '@patrianna/shared-utils/getParamFromString'

import { IS_BRAND_PULSZ } from 'config/brands'

export const analyticsConfig: InitAnalyticsProps = {
  coreConfig: {
    app: process.env.BRAND_NAME,
    debug: false,
    defaultOptions: {
      all: false,
      gtm: true,
    },
    plugins: {
      gtm: {
        containerId: process.env.GTM_KEY,
        ...(process.env.PROFILE !== 'prod' && {
          auth: getParamFromString(process.env.GTM_ENV_KEY || '', 'gtm_auth'),
          preview: getParamFromString(process.env.GTM_ENV_KEY || '', 'gtm_preview'),
        }),
        isFirstParty: true,
        enabled: true,
        debug: true,
        pageView: {
          trackAllPages: true,
        },
      },
      bloomreach: {
        key: process.env.BLOOMREACH_KEY,
        targetUrl: 'https://analytics-api.pulsz.com',
        websitePushID: process.env.WEBSITE_PUSH_ID,
        enabled: false,
        debug: false,
      },
      tiktok: {
        key: process.env.TIKTOK_PIXEL_ID,
        enabled: true,
        debug: false,
        pageView: {
          slots: { key: 'AddToCart' },
          register: { key: 'InitiateCheckout' },
          home: { key: 'ViewContent' },
        },
      },
      twitter: {
        profile: process.env.TWITTER_PIXEL_ID,
        enabled: true,
        debug: process.env.PROFILE !== 'prod',
        pageView: {
          home: { key: IS_BRAND_PULSZ ? 'tw-odo3i-pxwwk' : '', description: 'Content View' },
          register: { key: IS_BRAND_PULSZ ? 'tw-odo3i-pxvtt' : '', description: 'Checkout Initiated - View register' },
          slots: { key: IS_BRAND_PULSZ ? 'tw-odo3i-qdjyt' : '', description: 'Add to Cart - View slots' },
        },
      },
      optimizely: {
        url: '',
        enabled: false,
      },
      clarity: {
        profile: process.env.CLARITY,
        enabled: true,
      },
      graphyte: {
        url: process.env.GRAPHYTE_BASE_URL,
        profile: process.env.GRAPHYTE_API_KEY,
        brandKey: process.env.GRAPHYTE_BRAND_KEY,
        enabled: true,
        debug: false,
      },
      snowplow: {
        enabled: false,
        collectorUrl: '',
        trackerSettings: {
          appId: '',
        },
        pageView: {
          trackAllPages: true,
        },
      },
    },
  },
  scripts: {
    oneTrust: {
      scriptId: process.env.ONE_TRUST_KEY as string,
    },
    cookieConsolidator: {
      enableClickTracking: true,
      enableCookieMonitor: true,
    },
    vtrk: {
      enabled: false,
    },
    voluum: {
      enabled: false,
    },
    its: {
      brandName: process.env.TRAFFIC_SOURCE_SCRIPT,
    },
  },
}
